import React, { useEffect, useRef } from "react";
import { Box, Typography, Paper } from "@mui/material";

const CreditCardPayment = ({
  total,
  onPaymentDataChange,
  amountCard, // Changed from creditCartAmount
  setAmountCard, // Changed from setCreditCardAmount
}) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    // Auto-fill total on mount for speed, but only once to avoid loops
    if (!isInitialized.current && total > 0) {
      // setAmountCard(total);
      // onPaymentDataChange({ amount: total, rendu: 0 }, "creditcard"); // Fixed: changed from "cash" to "creditcard"
      isInitialized.current = true;
    }

    const handleVirtualInput = (e) => {
      if (e.detail.method === "creditcard" && e.detail.input === "amount") {
        // Fixed: changed from "cash" to "creditcard"
        const val = parseFloat(e.detail.value) || 0;
        setAmountCard(val);
        onPaymentDataChange(
          { amount: val, rendu: 0 }, // Credit cards don't have rendu
          "creditcard", // Fixed: changed from "cash" to "creditcard"
        );
      }
    };

    window.addEventListener("virtualKeyboardInput", handleVirtualInput);
    return () =>
      window.removeEventListener("virtualKeyboardInput", handleVirtualInput);
  }, [total, setAmountCard, onPaymentDataChange]); // Added missing dependencies

  const handlePhysicalKeyDown = (e) => {
    if (e.key === "Enter") return;
    let currentStr = amountCard.toString();
    if (e.key === "Backspace") currentStr = currentStr.slice(0, -1);
    else if (/[0-9.]/.test(e.key)) currentStr += e.key;

    const newVal = parseFloat(currentStr) || 0;
    setAmountCard(newVal);
    onPaymentDataChange(
      { amount: newVal, rendu: 0 }, // Credit cards don't have rendu
      "creditcard", // Fixed: changed from "cash" to "creditcard"
    );
  };

  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="caption" color="textSecondary">
        Cliquer pour taper le montant reçu
      </Typography>
      <Paper
        tabIndex={0}
        onKeyDown={handlePhysicalKeyDown}
        data-payment="creditcard" // Add this line
        onFocus={() =>
          window.dispatchEvent(
            new CustomEvent("virtualKeyboardFocus", {
              detail: { method: "creditcard", input: "amount" }, // Fixed: changed from "cash" to "creditcard"
            }),
          )
        }
        sx={{
          p: 1,
          fontSize: "1rem",
          textAlign: "right",
          border: "2px solid #1976d2", // Changed color to blue for credit card
          outline: "none",
          "&:focus": { bgcolor: "#e3f2fd" },
        }}
      >
        {amountCard || "0.000"} <small style={{ fontSize: "1rem" }}></small>
      </Paper>
    </Box>
  );
};

export default CreditCardPayment;
